const { getServerClientTimeDiff } = require('../../app/utils/getServerClientTimeDiff')
const APP = require('../APP')

/**
 * @param  {HTMLDivElement} el
 * @param  {} options
 */
const Clock = (el, options) => {
  const defaults = {
    updateTime: 500,
    showSeconds: false,
    serverDate: false,
  }

  const params = Object.assign({}, defaults, options)

  const lastTimeObj = {}
  /**
   * @param  {HTMLSpanElement} hoursNode
   * @param  {HTMLSpanElement} minutesNode
   * @param  {HTMLSpanElement} separatorNode
   */
  let hoursNode
  let minutesNode
  let separatorNode = false
  let separatorShowm = false
  let currentTimeObj
  let timeout
  let hoursDiff = 0
  let minutesDiff = 0

  const init = () => {
    if (params.serverDate) {
      const timeDiff = getServerClientTimeDiff(params.serverDate, APP.timezone)

      const serverDate = new Date(Date.now() - timeDiff)
      const userDate = new Date()

      hoursDiff = userDate.getHours() - serverDate.getHours()
      minutesDiff = userDate.getMinutes() - serverDate.getMinutes()
    }

    // eslint-disable-next-line no-param-reassign
    el.innerHTML =
      '' +
      '<span id="clockHours">00</span>' +
      '<span id="clockSeparator" class="clock-separator">:</span>' +
      '<span id="clockMinutes">00</span>'

    hoursNode = el.querySelector('#clockHours')
    minutesNode = el.querySelector('#clockMinutes')
    separatorNode = el.querySelector('#clockSeparator')

    timeout = setTimeout(update, params.updateTime)

    update()

    el.classList.remove('hidden')
  }

  const update = () => {
    clearTimeout(timeout)
    // console.log('update clock')
    render()
    timeout = setTimeout(update, params.updateTime)
  }

  const render = () => {
    currentTimeObj = getElapsedTimeString()

    if (lastTimeObj.hours !== currentTimeObj.hours) {
      hoursNode.innerHTML = currentTimeObj.hours
      lastTimeObj.hours = currentTimeObj.hours
    }
    if (lastTimeObj.minutes !== currentTimeObj.minutes) {
      minutesNode.innerHTML = currentTimeObj.minutes
      lastTimeObj.minutes = currentTimeObj.minutes
    }
    separatorShowm = !separatorShowm
    if (separatorShowm) {
      separatorNode.style.opacity = 0
    } else {
      separatorNode.style.opacity = 1
    }
  }

  const prettyTimeString = (num) => (num < 10 ? '0' : '') + num

  const getElapsedTimeString = () => {
    const d = new Date()
    let hours = d.getHours() - hoursDiff
    let minutes = d.getMinutes() - minutesDiff
    let seconds = d.getSeconds()

    hours = prettyTimeString(hours)
    minutes = prettyTimeString(minutes)
    seconds = prettyTimeString(seconds)

    return {
      hours,
      minutes,
      seconds,
    }
  }

  if (el) {
    init()
  }

  return el
}

module.exports = Clock
